import PaywallContainer from './paywall.container'

export default PaywallContainer
